import {moduloAutoconsumo} from "../diccionarios/autoconsumoModulo";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UtilsService} from "../../../shared/utils/utils.service";
import {CommonService} from "../../../shared/utils/common.service";


@Injectable({
  providedIn: 'root'
})
export class AutoconsumoMotivoPedidoService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
    this.url = this._util.getUrlAutoconsumo();
  }

  creacionMotivoPedido(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.autoconsumo.motivoPedido.creacion, payload);
  }

  actualizarMotivoPedido(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.autoconsumo.motivoPedido.actualizar, payload);
  }

  getAllMotivoPedido() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.autoconsumo.motivoPedido.getAll);
  }

  borrarMotivoPedido(payload) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.autoconsumo.motivoPedido.delete + payload.idMotivoPedido);
  }

}
